// src/lib/gazelle-staff.ts
export const GAZELLE_STAFF_EMAILS = [
  "csteffes@intelligentoffice.com",
  "dliss@intelligentoffice.com",
  "kleggat@gazl.co",
  "csteffes@gazl.co",
] as const;

export const GAZELLE_EMAIL_SET = new Set(GAZELLE_STAFF_EMAILS.map((e) => e.toLowerCase().trim()));

export function isGazelleEmail(email?: string | null): boolean {
  if (!email) return false;

  const normalized = email.toLowerCase().trim();

  return GAZELLE_EMAIL_SET.has(normalized) || normalized.endsWith("@gazl.co");
}
